import { useRouteMatch } from 'react-router-dom';
import API from '../API';

const FALLBACK_STORE = 'backroom';

export interface TenantPath {
  store: string;
  category: (id?: string) => string;
  item: (id: string) => string;
  search: (q: string) => string;
}

// Build URLs scoped to a specific tenant, regardless of which one is active.
// Use this when a result carries its own tenant (cross-tenant search results)
// so the card link routes the user into the correct shop.
export function pathsForTenant(store: string): TenantPath {
  return {
    store,
    category: (id?: string) => (id ? `/r/${store}/category/${id}` : `/r/${store}/category`),
    item: (id: string) => `/r/${store}/item/${id}`,
    search: (q: string) => `/r/${store}/search/${q}`,
  };
}

// Build URLs scoped to the currently-active tenant.
//
// Prefers the :store segment from the URL (so links inside a tenant page
// always point back into the same tenant), then falls back to API's active
// store for components rendered outside a tenant route (e.g. the global
// search field), and finally a hard default so links are never broken.
export function useTenantPath(): TenantPath {
  const match = useRouteMatch<{ store?: string }>('/r/:store');
  const store = match?.params.store ?? API.getStore() ?? FALLBACK_STORE;
  return pathsForTenant(store);
}
